import React from 'react'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import { Formik, Field, Form } from 'formik'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Button, Grid, Checkbox, Link } from '@material-ui/core'
import LiquidInputAdapter from '@src/components/LiquidInputAdapter'
import messages from '@configurator-messages'
import DownloadIcon from '@src/icons/DownloadIcon'
import AddIcon from '@material-ui/icons/Add'
import { ShippingMessageKey, ProductType, ErrorMessage } from '../enum'
import { configContext } from '../Ngso'
import { TubeProperties } from '../../../utils/enum'
import useDebounce from '@src/routes/Configurators/utils/ConfiguratorDebounce'
import NgsoValidationErrors from '../../../validations/NgsoValidationErrors'
import {
  convertToASCII,
  validateSurrogateCharacters,
} from '@src/routes/Configurators/utils/util'
import * as yup from 'yup'
import { useConfAddToMiniCartMutation } from '@src/mutations/ConfiguratorTubesMutation.generated'
import AddToCartItems from '@src/routes/Configurators/components/AddToCart/AddToCartItems'
import CircleLoader from '@src/components/CircleLoader'
import {
  SnackbarType,
  useGlobalSnackbar,
} from '@src/components/GlobalSnackbar/globalSnackBarContext'
import { loginRoute } from '@src/routes'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme: Theme) => {
  return {
    gridRow: {
      //borderTop: `1px solid ${theme.palette.grey[300]}`,
      padding: theme.spacing(3),
    },

    price: {
      textAlign: 'right',
    },
    summaryGrid: {
      padding: 0,
    },
    summaryGridItem: {
      '&:nth-child(1)': { width: '65%' },
      '&:nth-child(2)': { width: '35%' },
    },
    comments: {
      paddingRight: theme.spacing(5),
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },

    label: {
      fontWeight: theme.typography.fontWeightBold,
      //fontSize: theme.typography.pxToRem(12),
    },
    heading: {
      marginTop: theme.spacing(5.5),
      marginBottom: theme.spacing(4),
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
    },
    checkbox: {
      padding: theme.spacing(0, 0, 1, 0),
      color: theme.palette.grey[500],
    },
    additionalcheckboxtext: {
      fontSize: theme.typography.pxToRem(14),
      paddingLeft: theme.spacing(2),
    },
    orderInstruction: {
      marginBottom: theme.typography.pxToRem(8),
    },
    textarea: {
      width: '85%',
      //backgroundColor: theme.palette.grey[200],
    },
    subtotal: {
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
      paddingBottom: theme.typography.pxToRem(8),
      marginBottom: theme.typography.pxToRem(8),
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      paddingTop: theme.spacing(8),
    },
    button: {
      marginRight: theme.spacing(3.5),
    },
    downloadSummary: {
      color: theme.palette.primary.main,
    },
    links: {
      marginTop: theme.spacing(5),
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightBold,
      fontSize: theme.typography.pxToRem(16),
    },
    separator: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightRegular,
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
      color: theme.palette.grey[400],
    },
    buttonLink: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    sectionTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    shippingText: {
      fontSize: theme.typography.pxToRem(14),
    },
    priceAmountAlign: {
      paddingRight: theme.spacing(4),
    },
    heightButtonLink: {
      height: 24,
    },
    orderInstructionGrid: {
      padding: theme.spacing(2, 0, 1, 0),
    },
  }
})

export const SubtotalAndAddToCart = (props) => {
  const classes = useStyles()
  const router = useRouter()
  const {
    totalPrice,
    productDetails,
    saveSessionHandler,
    configuratorAddToMiniCart,
    clearSession,
  } = props
  const { state, dispatch } = React.useContext(configContext)
  const { sessionData, productInformation, isPageLoad } = state
  const tubeURL = `/configurator-order/summary/${productDetails.countryCode}/${productDetails.participantId}/${productDetails.locale}/${productDetails.type}`
  const plateURL = `/configurator-order/summary/plate?country=${productDetails.countryCode}&participantId=${productDetails.participantId}&locale=${productDetails.locale}&product=${productDetails.type}`
  const intl = useIntl()
  let [splChar] = React.useState<string>('')
  const { sapNextEnabled } = configuratorAddToMiniCart
  const { companionProducts } = productInformation
  const [callDebounceCall, setCallDebounceCall] = React.useState(false)
  const [additionalComments, setAdditionalComments] = React.useState('')
  const debouncedAdditionalData = useDebounce(
    additionalComments,
    TubeProperties.SEQUENCE_API_TIME
  )
  const [commentsCheckBox, setCommentsCheckBox] = React.useState(false)
  const [validationCommentsErrors, setValidationCommentsErrors] =
    React.useState<string[]>([])
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [totalPriceInCart, setTotalPriceInCart] = React.useState<string>('')
  const [totalItem, setTotalItem] = React.useState<number>(0)
  const { setGlobalSnackbarState } = useGlobalSnackbar()

  const [addToMiniCart, { data, loading }] = useConfAddToMiniCartMutation({
    // refetchQueries: [
    //   {
    //     query: QUICK_CART,
    //     variables: { id: CartRequestAction.Mini },
    //   },
    // ],
    // awaitRefetchQueries: true,
  })
  const commentLength = () => {
    let lengthOfComment = 0
    let maxLength = 0
    sessionData.forEach((data) => {
      data.wellList.forEach((well) => {
        if (well.comments.length > lengthOfComment) {
          lengthOfComment = well.comments.length
        }
      })
    })
    if (sapNextEnabled) {
      maxLength = 999 - lengthOfComment
    } else {
      maxLength = 90 - lengthOfComment
    }
    return maxLength
  }
  const checkSpecialChar = (args): string => {
    splChar = ''
    args.value.split('').forEach((c) => {
      if (!c.match(/^[a-zA-Z0-9_#*()., +.:[\-\]/]*$/) && !splChar.includes(c)) {
        if (splChar === '') {
          splChar = c
        } else {
          splChar = splChar + ', ' + c
        }
      }
    })
    return splChar
  }

  const handleComments = (value) => {
    setCallDebounceCall(true)
    setAdditionalComments(value)
    sessionData.forEach((plate) => {
      plate.wellList.forEach((well) => {
        well.additionalComments = value
      })
    })
    dispatch({
      type: 'UPDATE_NGSO_INPUT',
      data: [...state.sessionData],
    })
  }

  const handleCommentsError = (surrogateCharacters, error) => {
    const errors: string[] = []
    let invalidcharExist = false
    for (const err of error.errors) {
      if (
        err.includes(intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG))
      ) {
        surrogateCharacters.length !== 0
          ? errors.push(err + ', ' + surrogateCharacters)
          : errors.push(err)
        invalidcharExist = true
      } else {
        errors.push(err)
      }
    }
    if (!invalidcharExist && surrogateCharacters.length !== 0) {
      errors.push(
        `${intl.formatMessage(
          messages.CONF_SPL_CHAR_VALIDATION_MSG
        )} ${surrogateCharacters}`
      )
    }
    setValidationCommentsErrors(errors)
  }

  const handleCommentsOnChange = (value, isSaveToSession) => {
    value = convertToASCII(value)
    if (isSaveToSession) {
      handleComments(value)
    }
    const val = checkSpecialChar({ value })
    const surrogateCharacters = validateSurrogateCharacters(value)
    const validator = yup
      .string()
      .max(
        commentLength(),
        intl.formatMessage(messages.CONF_ADD_INFO_MAX_VALIDATION_MSG) +
          commentLength()
      )
      .matches(
        /^[^~!@$^|{}?<>%&—’'"=;\\]*$/,
        `${intl.formatMessage(messages.CONF_SPL_CHAR_VALIDATION_MSG)} ${val}`
      )

    try {
      if (surrogateCharacters.length !== 0) {
        setValidationCommentsErrors([
          `${intl.formatMessage(
            messages.CONF_SPL_CHAR_VALIDATION_MSG
          )} ${surrogateCharacters}`,
        ])
      } else {
        setValidationCommentsErrors([])
      }
      validator.validateSync(value, {
        abortEarly: false,
      })
    } catch (error) {
      handleCommentsError(surrogateCharacters, error)
    }
    return undefined
  }

  React.useEffect(
    () => {
      if (callDebounceCall) {
        setCallDebounceCall(false)
        saveSessionHandler(sessionData, false)
      }
    },
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedAdditionalData]
  )
  React.useEffect(() => {
    if (
      isPageLoad &&
      sessionData[0].wellList[0].additionalComments &&
      sessionData[0].wellList[0].additionalComments.length > 0
    ) {
      setCommentsCheckBox(true)
      setAdditionalComments(sessionData[0].wellList[0].additionalComments)
      handleCommentsOnChange(
        sessionData[0].wellList[0].additionalComments,
        false
      )
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageLoad])

  const handleAknowledgeCheckBox = (value) => {
    setCommentsCheckBox(value)
    if (!value) {
      handleComments('')
      setValidationCommentsErrors([])
    }
  }
  const handleAddToCart = async () => {
    await addToMiniCart({
      variables: { input: configuratorAddToMiniCart },
      fetchPolicy: 'no-cache',
    })
  }
  //configuring the Configurator product data for sending it to GA
  React.useEffect(() => {
    if (!data || data?.confAddToMiniCart?.serverError) return

    switch (data?.confAddToMiniCart?.result) {
      case ErrorMessage.Success:
        setTotalPriceInCart(
          sessionData[0].wellList[0].priceHeaderError ? '--' : totalPrice
        )
        if (productDetails.type === ProductType.NgsoPlates) {
          setTotalItem(sessionData.length)
        } else {
          setTotalItem(sessionData[0].wellList.length)
        }
        setDialogOpen(true)
        break

      case ErrorMessage.SessionDataEmpty:
        clearSession(true)
        break

      case ErrorMessage.AccessTokenExpire:
        router.push(loginRoute.index())
        setGlobalSnackbarState({
          open: true,
          message: (
            <FormattedMessage
              {...messages.USER_NOT_AUTHORIZED_OR_TOKEN_EXPIRED}
            />
          ),
          variant: SnackbarType.Error,
        })
        break
      default:
        break
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
  return (
    <>
      <div>
        <Grid
          container
          direction="row"
          className={clsx(classes.gridRow, classes.summaryGrid)}
        >
          <Grid
            item
            className={clsx(classes.summaryGridItem, classes.comments)}
          >
            <div>
              <div className={clsx(classes.heading, classes.orderInstruction)}>
                <FormattedMessage {...messages.CONF_ORDER_INSTRUCTION} />
              </div>
              <div className={classes.orderInstructionGrid}>
                <Checkbox
                  className={classes.checkbox}
                  color="primary"
                  checked={commentsCheckBox}
                  value={commentsCheckBox}
                  onChange={() => handleAknowledgeCheckBox(!commentsCheckBox)}
                />
                <span className={classes.additionalcheckboxtext}>
                  <FormattedMessage {...messages.CONF_ADD_COMMENT_ACK_TEXT} />
                </span>
              </div>
              <Formik
                initialValues={{ comments: '' }}
                validateOnChange={false}
                onSubmit={(values, actions) => {
                  setTimeout(() => {
                    actions.setSubmitting(false)
                  }, 1000)
                }}
              >
                {() => {
                  return (
                    <Form>
                      <Field
                        name="message"
                        filled
                        component={LiquidInputAdapter}
                        multiline
                        spellcheck={'false'}
                        cols={30}
                        rows={2}
                        value={additionalComments}
                        className={classes.textarea}
                        disabled={!commentsCheckBox}
                        onChange={(e) => {
                          handleCommentsOnChange(e.target.value, true)
                        }}
                        inputProps={{
                          'data-scrub': 'true',
                        }}
                      />
                    </Form>
                  )
                }}
              </Formik>
              <NgsoValidationErrors errors={validationCommentsErrors} />
            </div>
            <div>
              <Grid
                container
                direction="row"
                className={clsx(classes.links, classes.heightButtonLink)}
              >
                <Grid item className={classes.buttonLink}>
                  <DownloadIcon /> &nbsp;&nbsp;
                  <Link
                    download
                    href={
                      productDetails.type === ProductType.NgsoTubes
                        ? tubeURL
                        : plateURL
                    }
                    className={classes.downloadSummary}
                  >
                    <FormattedMessage
                      {...messages.CONF_DOWNLOAD_PRINT_SUMMARY}
                    />
                  </Link>
                </Grid>
                <Grid item className={classes.separator}>
                  <span>|</span>
                </Grid>
                <Grid
                  item
                  className={classes.buttonLink}
                  onClick={props.handlePrev}
                >
                  <AddIcon />
                  <FormattedMessage {...messages.CONF_ADD_OLIGOS} />
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item className={classes.summaryGridItem}>
            <div
              className={clsx(
                classes.heading,
                classes.subtotal,
                classes.sectionTitle
              )}
            >
              <div>
                <FormattedMessage
                  id="CART_SUBTOTAL"
                  defaultMessage="Subtotal"
                />
                :
              </div>
              <div className={classes.priceAmountAlign}>
                <span>
                  {' '}
                  {sessionData[0].wellList[0].priceHeaderError
                    ? '--'
                    : totalPrice}{' '}
                </span>
              </div>
            </div>
            <div className={classes.shippingText}>
              <span className={classes.label}>
                <FormattedMessage
                  id="CART_SHIPPING"
                  defaultMessage="Shipping"
                />
                :
              </span>
              <span>
                &nbsp;
                {props.shipping && (
                  <FormattedMessage
                    {...messages[ShippingMessageKey[props.shipping]]}
                  />
                )}{' '}
                <br />
                <FormattedMessage
                  {...messages.CONF_NGSO_APPLICATIONFREIGHT_TAX}
                />
                <br />
                <FormattedMessage {...messages.CONF_PROMOTIONAL_CODES} />
              </span>
            </div>
            <div className={classes.buttonContainer}>
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                className={classes.button}
                onClick={props.handlePrev}
              >
                <FormattedMessage {...messages.PREVIOUS_STEP} />
              </Button>
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={
                  ((productDetails.type === ProductType.NgsoTubes &&
                    !sessionData[0].wellList[0].ngsoType) ||
                  validationCommentsErrors.length
                    ? true
                    : false) || loading
                }
                onClick={handleAddToCart}
              >
                <FormattedMessage
                  id="ADD_TO_CART"
                  defaultMessage="Add to Cart"
                />
              </Button>
            </div>
          </Grid>
          <AddToCartItems
            dialogOpen={dialogOpen}
            setDialogOpen={setDialogOpen}
            price={totalPriceInCart}
            totalItem={totalItem}
            companionProducts={companionProducts}
            productType={productDetails.productType}
          />
        </Grid>
      </div>
      {loading && <CircleLoader />}
    </>
  )
}

export default SubtotalAndAddToCart
